import React from "react"
import Helmet from "react-helmet"
import "../../Main/Main.scss"
import TopBanner from "../../../components/TopBanner/TopBanner"
import PriceCalculator from "../../../components/PriceCalculator/PriceCalculator"
import LandingFeatures from "../../../components/LandingFeatures/LandingFeatures"
import LandingHelp from "../../../components/LandingHelp/LandingHelp"

class CityRovenki extends React.Component {
    componentDidMount() {
        this.moveToHash()
    }

    moveToHash() {
        const hash = window.location.hash
        if ( hash ) {
            const element = document.querySelector(hash)
            if ( element ) {
                element.scrollIntoView({ behavior: "smooth" })
            }
        }
    }

    render() {
        return (
            <section className="Main City-Rovenki">
                <Helmet>
                    <title>Такси Ровеньки - Флика такси</title>
                    <meta name="description" content="Профессиональное такси в Ровеньках для межгородних поездок. Безопасность, комфорт и надёжность - наш приоритет! Закажите такси прямо сейчас." />
                    <meta name="keywords" content="Такси, Ровеньки, межгороднее такси, перевозки, надёжное такси, комфортное такси, заказ такси, безопасные поездки." />
                    <meta property="og:title" content="Такси Ровеньки" />
                    <meta property="og:description" content="Закажите надежное такси в Ровеньках для междугородних поездок с комфортными автомобилями и опытными водителями. Путешествуйте безопасно и удобно, оставляя заявку прямо сейчас!" />
                    <meta property="og:url" content="https://fleeka.ru/rovenki/" />
                </Helmet>
                <TopBanner city={"Ровеньки"} />
                <PriceCalculator />
                <LandingFeatures />
                <LandingHelp />
            </section>
        )
    }
}

export default CityRovenki